export default __webpack_public_path__ + "static/media/trus12.0cd3b6b2.png";